import { reduxForm } from 'redux-form';
import Component from './SubUserEditPriceForm.jsx';
import { validate } from './validate.js';

const initialValues = {
  minPrice: '',
  maxPrice: '',
  subUserId: '',
};

const SubUserEditPriceForm = reduxForm({
  form: 'formSetPasswordFile',
  initialValues,
  enableReinitialize: true,
  productGeneralMaxPrice: 0,
  productGeneralMinPrice: 0,
  validate(values, props) {
    return validate(values, props.productGeneralMaxPrice, props.productGeneralMinPrice);
  }
})(Component);

export default SubUserEditPriceForm;
